import { PaymentApiErrorCode } from '@mfw/common';

import { BadRequestError } from '../../api/http';

/**
 * Detects the BE 400 "no card" during premium subscribe (F3.1) and premium
 * report subscribe. Primary signal is the machine-readable `code` (the message
 * is TRANSLATED per user locale, so it must not be relied on); the message
 * substrings remain only as a transitional fallback for a BE that predates the
 * code. On a miss the flow safely degrades to the global error toast.
 */
export function isNoSavedCardError(error: unknown) {
  if (!(error instanceof BadRequestError)) {
    return false;
  }
  if (error.code === PaymentApiErrorCode.NO_SAVED_CARD) {
    return true;
  }
  return (
    typeof error.message === 'string' &&
    (error.message.includes('No saved card') ||
      error.message.includes('Nema sačuvane kartice'))
  );
}
